// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-8 — Detalle de pedido. Acotado a .order-detail (el CSS de CRA es global). */
.order-detail {
  padding: 40px;
  max-width: 1100px;
  margin: 0 auto;
}

.order-loading { color: #777; font-size: 15px; }

.order-detail .order-back {
  border: none;
  background: transparent;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  padding: 0 0 18px;
}

.order-detail .order-back:hover { color: var(--button-color); }

.order-error {
  padding: 14px 16px;
  border-radius: 8px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 14px;
}

.order-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 26px;
}

.order-client { font-size: 23px; font-weight: 600; color: #000; margin: 0 0 4px; }
.order-subtitle { font-size: 14px; color: #666; margin: 0; }

.order-badge {
  padding: 5px 14px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.order-badge.abierto { background: #dbeafe; color: #1e40af; }
.order-badge.cerrado { background: #d1fae5; color: #065f46; }

.order-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 14px;
  margin-bottom: 30px;
}

.order-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 10px;
}

.order-card-label { font-size: 12px; color: #888; text-transform: uppercase; letter-spacing: 0.4px; }
.order-card-value { font-size: 21px; font-weight: 600; color: #000; }
.order-card-value.origen { font-size: 15px; font-weight: 500; }
.order-card-hint { font-size: 12px; color: #888; }

.order-section { margin-bottom: 30px; }

.order-section h2 {
  font-size: 15px;
  font-weight: 600;
  color: #000;
  margin: 0 0 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ececec;
}

.order-description { font-size: 15px; color: #222; margin: 0; white-space: pre-line; }

/* LAKPED-16.5: una línea por artículo en vez del texto del Access */
.order-lineas { width: 100%; border-collapse: collapse; font-size: 14px; }
.order-lineas th {
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
}
.order-lineas td { padding: 8px; border-bottom: 1px solid #f4f4f4; color: #222; }
.order-lineas th.der, .order-lineas td.der { text-align: right; }
.order-notes { font-size: 14px; color: #666; margin: 8px 0 0; white-space: pre-line; }

.order-detail .order-plano-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 8px;
  padding: 9px 14px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.order-detail .order-plano-link:hover { border-color: var(--button-color); color: var(--button-color); }

.order-sin-plano { font-size: 14px; color: #777; margin: 0; }

.order-doc-path {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: #999;
  overflow-wrap: anywhere;
}

.order-parts-wrapper { overflow-x: auto; }

.order-parts { width: 100%; border-collapse: collapse; background: #fff; }

.order-parts th {
  padding: 11px 14px;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  background: #f7f7f7;
  border-bottom: 1px solid #ececec;
  white-space: nowrap;
}

.order-parts td {
  padding: 11px 14px;
  font-size: 14px;
  color: #000;
  border-bottom: 1px solid #f2f2f2;
}

.order-parts .col-num { text-align: right; white-space: nowrap; }
.order-parts .col-codigo { color: #555; white-space: nowrap; }

.order-parts tfoot td {
  font-weight: 600;
  background: #fafafa;
  border-bottom: none;
}

@media (max-width: 760px) {
  .order-detail { padding: 20px 16px; }
}

/* Descripciones largas (las hay de 629 caracteres): se recortan para que los
   partes de trabajo no queden a 3.000 px de scroll. */
.order-description.collapsed {
  max-height: 9em;
  overflow: hidden;
  position: relative;
}

.order-description.collapsed::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3em;
  background: linear-gradient(to bottom, rgba(245, 245, 245, 0), var(--background-color, #f5f5f5));
}

.order-detail .order-desc-toggle {
  margin-top: 8px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--button-color);
  font-size: 13px;
  cursor: pointer;
}

.order-detail .order-desc-toggle:hover { text-decoration: underline; }

/* Edición del pedido desde su ficha */
.order-head-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* Mismo formato que los botones de la oferta y en negro (reunión del 04-11): los claros
   parecían etiquetas o campos de texto. Solo "Cancelar" dentro de los pop-ups sigue en blanco. */
.order-detail .order-action {
  padding: 9px 16px;
  border: 1px solid #111;
  border-radius: 8px;
  background: #111;
  color: #fff;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.order-detail .order-action:hover:not(:disabled) { background: #333; }

.order-detail .order-modal .order-action { background: #fff; border-color: #ccc; color: #333; }
.order-detail .order-modal .order-action:hover:not(:disabled) { background: #fff; border-color: #111; }

.order-detail .order-action:disabled { opacity: 0.55; cursor: not-allowed; }

.order-edit-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
}

.order-edit-field { display: flex; flex-direction: column; gap: 5px; }
.order-edit-wide { grid-column: span 2; }
.order-edit-full { grid-column: 1 / -1; }

.order-edit-field label {
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.order-detail .order-edit-field input,
.order-detail .order-edit-field textarea {
  padding: 9px 11px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #000;
  font-family: inherit;
  background: #fff;
  resize: vertical;
}

.order-detail .order-edit-field input:focus,
.order-detail .order-edit-field textarea:focus {
  outline: none;
  border-color: var(--button-color);
}

.order-edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.order-detail .order-cancel,
.order-detail .order-save {
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.order-detail .order-cancel { border: 1px solid #d5d5d5; background: #fff; color: #555; }
.order-detail .order-save { border: 1px solid transparent; background: var(--button-color); color: #fff; }
.order-detail .order-save:hover:not(:disabled) { opacity: 0.9; }
.order-detail .order-cancel:disabled,
.order-detail .order-save:disabled { opacity: 0.55; cursor: not-allowed; }

@media (max-width: 760px) {
  .order-edit-wide { grid-column: 1 / -1; }
}

/* LAKPED-5: volver a la oferta de la que salió el pedido */
.order-detail .order-card-link {
  margin-top: 6px; padding: 0; border: none; background: none;
  color: #1d6fb8; font-size: 12px; cursor: pointer; text-align: left;
}
.order-detail .order-card-link:hover { text-decoration: underline; }

/* Apuntar un parte: es lo que hace que la calculadora aprenda */
.order-parts-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.order-parts-head h2 { margin: 0; }

.order-part-field { display: flex; flex-direction: column; gap: 5px; min-width: 0; }
.order-part-field label { font-size: 12px; color: #666; }
.order-part-opt { font-size: 11.5px; color: #999; }
.order-part-field input,
.order-part-field select {
  padding: 8px 10px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: #fff;
}
.order-part-acciones { display: flex; justify-content: flex-end; gap: 10px; margin-top: 18px; }
.order-detail .order-part-save {
  border: 1px solid #111; background: #111; color: #fff;
  border-radius: 8px; padding: 9px 18px; font-size: 14px; cursor: pointer;
}
.order-detail .order-part-save:hover:not(:disabled) { opacity: 0.9; }
.order-detail .order-part-save:disabled { opacity: 0.5; cursor: not-allowed; }

@media (max-width: 760px) {
  }

/* ───────── LAKPED-16.6: albarán, dos tiempos y el parte en pop-up ───────── */

.order-albaran { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; }

.order-detail .order-albaran input {
  font: inherit;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 10px;
  max-width: 240px;
}

.order-albaran-ok { font-size: 12.5px; color: #157347; }

/* Trabajado vs facturado */
.order-facturable { margin-top: 14px; }

.order-facturable-barra {
  background: #eee;
  border-radius: 5px;
  height: 10px;
  overflow: hidden;
}

.order-facturable-barra i { display: block; height: 100%; background: #1a9b5a; }
.order-facturable p { font-size: 12.5px; color: #777; margin: 6px 0 0; }

/* Pop-up del parte */
.order-modal-fondo {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 50;
}

.order-modal {
  background: #fff;
  border-radius: 12px;
  padding: 24px 26px;
  width: 100%;
  max-width: 720px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
}

.order-modal h2 { font-size: 18px; font-weight: 600; margin: 0 0 4px; color: #1b1b1b; }
.order-modal-sub { font-size: 13px; color: #777; margin: 0 0 18px; }

.order-modal-campos {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 14px;
  align-items: start;
}

.order-modal-ancho { margin-top: 14px; }

.order-modal-aviso {
  font-size: 13px;
  color: #5a2a00;
  background: #fff0e3;
  border-left: 4px solid #e46a00;
  border-radius: 0 6px 6px 0;
  padding: 9px 12px;
  margin: 14px 0 0;
}

.order-detail .order-part-readonly { background: #f5f5f5; color: #555; }

.order-motivos { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }

.order-detail .order-motivo {
  border: 1px solid #ddd;
  background: #fafafa;
  border-radius: 14px;
  padding: 3px 10px;
  font: inherit;
  font-size: 12px;
  color: #555;
  cursor: pointer;
}

.order-detail .order-motivo:hover { border-color: #111; color: #111; }

.order-modal-cierre { max-width: 520px; }

.order-cierre { margin: 0; display: grid; gap: 10px; }
.order-cierre > div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
}
.order-cierre dt { font-size: 13px; color: #777; margin: 0; }
.order-cierre dd { font-size: 14px; color: #1b1b1b; font-weight: 500; margin: 0; }
.order-cierre dd.desvio { color: #8a4b00; }

/* La hoja que se imprime para el taller: el cliente, el pedido y sus líneas, nada más.
   Fuera las horas, el albarán y los partes, que son cosa de la oficina. */
@media print {
  body { background: #fff !important; }
  .header, .order-back, .order-head-actions, .order-cards, .order-modal-fondo,
  .order-section-albaran, .order-section-partes, .order-card-link { display: none !important; }
  .order-detail { padding: 0; max-width: 100%; }
  .order-section { page-break-inside: avoid; break-inside: avoid; }
}

/* LAKPED-25: adjuntar el documento del cliente desde el pedido. El input va escondido dentro del botón. */
.order-detail .order-adjuntar { position: relative; overflow: hidden; display: inline-block; }
.order-detail .order-adjuntar input { position: absolute; inset: 0; opacity: 0; cursor: pointer; }
.order-detail .order-adjuntar.ocupado { opacity: 0.6; }
`, "",{"version":3,"sources":["webpack://./src/pages/OrderDetailPage.css"],"names":[],"mappings":"AAAA,qFAAqF;AACrF;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB,WAAW,EAAE,eAAe,EAAE;;AAE/C;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,kCAAkC,0BAA0B,EAAE;;AAE9D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,eAAe,EAAE;AACjF,kBAAkB,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE;;AAE3D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oBAAoB,eAAe,EAAE,WAAW,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACpG,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACpE,2BAA2B,eAAe,EAAE,gBAAgB,EAAE;AAC9D,mBAAmB,eAAe,EAAE,WAAW,EAAE;;AAEjD,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,qBAAqB,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE,qBAAqB,EAAE;;AAErF,oEAAoE;AACpE,gBAAgB,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACzE;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,mBAAmB,YAAY,EAAE,gCAAgC,EAAE,WAAW,EAAE;AAChF,6CAA6C,iBAAiB,EAAE;AAChE,eAAe,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE,qBAAqB,EAAE;;AAErF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,qDAAqD;AACvD;;AAEA,wCAAwC,iCAAiC,EAAE,0BAA0B,EAAE;;AAEvG,mBAAmB,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE;;AAE5D;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA,uBAAuB,gBAAgB,EAAE;;AAEzC,eAAe,WAAW,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;;AAEzE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gCAAgC;AAClC;;AAEA,wBAAwB,iBAAiB,EAAE,mBAAmB,EAAE;AAChE,2BAA2B,WAAW,EAAE,mBAAmB,EAAE;;AAE7D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,kBAAkB,EAAE;AACtC;;AAEA;sDACsD;AACtD;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gGAAgG;AAClG;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA,yCAAyC,0BAA0B,EAAE;;AAErE,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;iGACiG;AACjG;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA,mDAAmD,gBAAgB,EAAE;;AAErE,2CAA2C,gBAAgB,EAAE,kBAAkB,EAAE,WAAW,EAAE;AAC9F,gEAAgE,gBAAgB,EAAE,kBAAkB,EAAE;;AAEtG,uCAAuC,aAAa,EAAE,mBAAmB,EAAE;;AAE3E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B,yBAAyB,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACxF,4BAA4B,6BAA6B,EAAE,+BAA+B,EAAE,WAAW,EAAE;AACzG,iDAAiD,YAAY,EAAE;AAC/D;qCACqC,aAAa,EAAE,mBAAmB,EAAE;;AAEzE;EACE,mBAAmB,mBAAmB,EAAE;AAC1C;;AAEA,2DAA2D;AAC3D;EACE,eAAe,EAAE,UAAU,EAAE,YAAY,EAAE,gBAAgB;EAC3D,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB;AACpE;AACA,uCAAuC,0BAA0B,EAAE;;AAEnE,gEAAgE;AAChE,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACnG,uBAAuB,SAAS,EAAE;;AAElC,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACnF,0BAA0B,eAAe,EAAE,WAAW,EAAE;AACxD,kBAAkB,iBAAiB,EAAE,WAAW,EAAE;AAClD;;EAEE,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;AAClG;AACA,uBAAuB,aAAa,EAAE,yBAAyB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC9F;EACE,sBAAsB,EAAE,gBAAgB,EAAE,WAAW;EACrD,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe;AACzE;AACA,sDAAsD,YAAY,EAAE;AACpE,0CAA0C,YAAY,EAAE,mBAAmB,EAAE;;AAE7E;EACE;;AAEF,+EAA+E;;AAE/E,iBAAiB,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAEjF;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oBAAoB,iBAAiB,EAAE,cAAc,EAAE;;AAEvD,2BAA2B;AAC3B,oBAAoB,gBAAgB,EAAE;;AAEtC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,4BAA4B,cAAc,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC/E,sBAAsB,iBAAiB,EAAE,WAAW,EAAE,eAAe,EAAE;;AAEvE,qBAAqB;AACrB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACtF,mBAAmB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEnE;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qCAAqC,mBAAmB,EAAE,WAAW,EAAE;;AAEvE,iBAAiB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAE5E;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,oCAAoC,kBAAkB,EAAE,WAAW,EAAE;;AAErE,sBAAsB,gBAAgB,EAAE;;AAExC,gBAAgB,SAAS,EAAE,aAAa,EAAE,SAAS,EAAE;AACrD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;AACA,mBAAmB,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE;AAC5D,mBAAmB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACjF,0BAA0B,cAAc,EAAE;;AAE1C;0EAC0E;AAC1E;EACE,OAAO,2BAA2B,EAAE;EACpC;oEACkE,wBAAwB,EAAE;EAC5F,gBAAgB,UAAU,EAAE,eAAe,EAAE;EAC7C,iBAAiB,wBAAmB,EAAnB,mBAAmB,EAAE;AACxC;;AAEA,0GAA0G;AAC1G,gCAAgC,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC7F,sCAAsC,kBAAkB,EAAE,QAAQ,EAAE,UAAU,EAAE,eAAe,EAAE;AACjG,wCAAwC,YAAY,EAAE","sourcesContent":["/* LAKPED-8 — Detalle de pedido. Acotado a .order-detail (el CSS de CRA es global). */\n.order-detail {\n  padding: 40px;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.order-loading { color: #777; font-size: 15px; }\n\n.order-detail .order-back {\n  border: none;\n  background: transparent;\n  color: #666;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0 0 18px;\n}\n\n.order-detail .order-back:hover { color: var(--button-color); }\n\n.order-error {\n  padding: 14px 16px;\n  border-radius: 8px;\n  background: #fee2e2;\n  color: #991b1b;\n  font-size: 14px;\n}\n\n.order-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 26px;\n}\n\n.order-client { font-size: 23px; font-weight: 600; color: #000; margin: 0 0 4px; }\n.order-subtitle { font-size: 14px; color: #666; margin: 0; }\n\n.order-badge {\n  padding: 5px 14px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.order-badge.abierto { background: #dbeafe; color: #1e40af; }\n.order-badge.cerrado { background: #d1fae5; color: #065f46; }\n\n.order-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 14px;\n  margin-bottom: 30px;\n}\n\n.order-card {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 16px 18px;\n  background: #fff;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n}\n\n.order-card-label { font-size: 12px; color: #888; text-transform: uppercase; letter-spacing: 0.4px; }\n.order-card-value { font-size: 21px; font-weight: 600; color: #000; }\n.order-card-value.origen { font-size: 15px; font-weight: 500; }\n.order-card-hint { font-size: 12px; color: #888; }\n\n.order-section { margin-bottom: 30px; }\n\n.order-section h2 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #000;\n  margin: 0 0 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #ececec;\n}\n\n.order-description { font-size: 15px; color: #222; margin: 0; white-space: pre-line; }\n\n/* LAKPED-16.5: una línea por artículo en vez del texto del Access */\n.order-lineas { width: 100%; border-collapse: collapse; font-size: 14px; }\n.order-lineas th {\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  padding: 6px 8px;\n  border-bottom: 1px solid #eee;\n}\n.order-lineas td { padding: 8px; border-bottom: 1px solid #f4f4f4; color: #222; }\n.order-lineas th.der, .order-lineas td.der { text-align: right; }\n.order-notes { font-size: 14px; color: #666; margin: 8px 0 0; white-space: pre-line; }\n\n.order-detail .order-plano-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  border-radius: 8px;\n  padding: 9px 14px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n}\n\n.order-detail .order-plano-link:hover { border-color: var(--button-color); color: var(--button-color); }\n\n.order-sin-plano { font-size: 14px; color: #777; margin: 0; }\n\n.order-doc-path {\n  display: block;\n  margin-top: 5px;\n  font-size: 12px;\n  color: #999;\n  overflow-wrap: anywhere;\n}\n\n.order-parts-wrapper { overflow-x: auto; }\n\n.order-parts { width: 100%; border-collapse: collapse; background: #fff; }\n\n.order-parts th {\n  padding: 11px 14px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 500;\n  color: #555;\n  background: #f7f7f7;\n  border-bottom: 1px solid #ececec;\n  white-space: nowrap;\n}\n\n.order-parts td {\n  padding: 11px 14px;\n  font-size: 14px;\n  color: #000;\n  border-bottom: 1px solid #f2f2f2;\n}\n\n.order-parts .col-num { text-align: right; white-space: nowrap; }\n.order-parts .col-codigo { color: #555; white-space: nowrap; }\n\n.order-parts tfoot td {\n  font-weight: 600;\n  background: #fafafa;\n  border-bottom: none;\n}\n\n@media (max-width: 760px) {\n  .order-detail { padding: 20px 16px; }\n}\n\n/* Descripciones largas (las hay de 629 caracteres): se recortan para que los\n   partes de trabajo no queden a 3.000 px de scroll. */\n.order-description.collapsed {\n  max-height: 9em;\n  overflow: hidden;\n  position: relative;\n}\n\n.order-description.collapsed::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 3em;\n  background: linear-gradient(to bottom, rgba(245, 245, 245, 0), var(--background-color, #f5f5f5));\n}\n\n.order-detail .order-desc-toggle {\n  margin-top: 8px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--button-color);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.order-detail .order-desc-toggle:hover { text-decoration: underline; }\n\n/* Edición del pedido desde su ficha */\n.order-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* Mismo formato que los botones de la oferta y en negro (reunión del 04-11): los claros\n   parecían etiquetas o campos de texto. Solo \"Cancelar\" dentro de los pop-ups sigue en blanco. */\n.order-detail .order-action {\n  padding: 9px 16px;\n  border: 1px solid #111;\n  border-radius: 8px;\n  background: #111;\n  color: #fff;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.order-detail .order-action:hover:not(:disabled) { background: #333; }\n\n.order-detail .order-modal .order-action { background: #fff; border-color: #ccc; color: #333; }\n.order-detail .order-modal .order-action:hover:not(:disabled) { background: #fff; border-color: #111; }\n\n.order-detail .order-action:disabled { opacity: 0.55; cursor: not-allowed; }\n\n.order-edit-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 14px;\n}\n\n.order-edit-field { display: flex; flex-direction: column; gap: 5px; }\n.order-edit-wide { grid-column: span 2; }\n.order-edit-full { grid-column: 1 / -1; }\n\n.order-edit-field label {\n  font-size: 12px;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.order-detail .order-edit-field input,\n.order-detail .order-edit-field textarea {\n  padding: 9px 11px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #000;\n  font-family: inherit;\n  background: #fff;\n  resize: vertical;\n}\n\n.order-detail .order-edit-field input:focus,\n.order-detail .order-edit-field textarea:focus {\n  outline: none;\n  border-color: var(--button-color);\n}\n\n.order-edit-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.order-detail .order-cancel,\n.order-detail .order-save {\n  padding: 9px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.order-detail .order-cancel { border: 1px solid #d5d5d5; background: #fff; color: #555; }\n.order-detail .order-save { border: 1px solid transparent; background: var(--button-color); color: #fff; }\n.order-detail .order-save:hover:not(:disabled) { opacity: 0.9; }\n.order-detail .order-cancel:disabled,\n.order-detail .order-save:disabled { opacity: 0.55; cursor: not-allowed; }\n\n@media (max-width: 760px) {\n  .order-edit-wide { grid-column: 1 / -1; }\n}\n\n/* LAKPED-5: volver a la oferta de la que salió el pedido */\n.order-detail .order-card-link {\n  margin-top: 6px; padding: 0; border: none; background: none;\n  color: #1d6fb8; font-size: 12px; cursor: pointer; text-align: left;\n}\n.order-detail .order-card-link:hover { text-decoration: underline; }\n\n/* Apuntar un parte: es lo que hace que la calculadora aprenda */\n.order-parts-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; }\n.order-parts-head h2 { margin: 0; }\n\n.order-part-field { display: flex; flex-direction: column; gap: 5px; min-width: 0; }\n.order-part-field label { font-size: 12px; color: #666; }\n.order-part-opt { font-size: 11.5px; color: #999; }\n.order-part-field input,\n.order-part-field select {\n  padding: 8px 10px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; background: #fff;\n}\n.order-part-acciones { display: flex; justify-content: flex-end; gap: 10px; margin-top: 18px; }\n.order-detail .order-part-save {\n  border: 1px solid #111; background: #111; color: #fff;\n  border-radius: 8px; padding: 9px 18px; font-size: 14px; cursor: pointer;\n}\n.order-detail .order-part-save:hover:not(:disabled) { opacity: 0.9; }\n.order-detail .order-part-save:disabled { opacity: 0.5; cursor: not-allowed; }\n\n@media (max-width: 760px) {\n  }\n\n/* ───────── LAKPED-16.6: albarán, dos tiempos y el parte en pop-up ───────── */\n\n.order-albaran { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; }\n\n.order-detail .order-albaran input {\n  font: inherit;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 8px 10px;\n  max-width: 240px;\n}\n\n.order-albaran-ok { font-size: 12.5px; color: #157347; }\n\n/* Trabajado vs facturado */\n.order-facturable { margin-top: 14px; }\n\n.order-facturable-barra {\n  background: #eee;\n  border-radius: 5px;\n  height: 10px;\n  overflow: hidden;\n}\n\n.order-facturable-barra i { display: block; height: 100%; background: #1a9b5a; }\n.order-facturable p { font-size: 12.5px; color: #777; margin: 6px 0 0; }\n\n/* Pop-up del parte */\n.order-modal-fondo {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 50;\n}\n\n.order-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px 26px;\n  width: 100%;\n  max-width: 720px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);\n}\n\n.order-modal h2 { font-size: 18px; font-weight: 600; margin: 0 0 4px; color: #1b1b1b; }\n.order-modal-sub { font-size: 13px; color: #777; margin: 0 0 18px; }\n\n.order-modal-campos {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 14px;\n  align-items: start;\n}\n\n.order-modal-ancho { margin-top: 14px; }\n\n.order-modal-aviso {\n  font-size: 13px;\n  color: #5a2a00;\n  background: #fff0e3;\n  border-left: 4px solid #e46a00;\n  border-radius: 0 6px 6px 0;\n  padding: 9px 12px;\n  margin: 14px 0 0;\n}\n\n.order-detail .order-part-readonly { background: #f5f5f5; color: #555; }\n\n.order-motivos { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }\n\n.order-detail .order-motivo {\n  border: 1px solid #ddd;\n  background: #fafafa;\n  border-radius: 14px;\n  padding: 3px 10px;\n  font: inherit;\n  font-size: 12px;\n  color: #555;\n  cursor: pointer;\n}\n\n.order-detail .order-motivo:hover { border-color: #111; color: #111; }\n\n.order-modal-cierre { max-width: 520px; }\n\n.order-cierre { margin: 0; display: grid; gap: 10px; }\n.order-cierre > div {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid #f0f0f0;\n  padding-bottom: 8px;\n}\n.order-cierre dt { font-size: 13px; color: #777; margin: 0; }\n.order-cierre dd { font-size: 14px; color: #1b1b1b; font-weight: 500; margin: 0; }\n.order-cierre dd.desvio { color: #8a4b00; }\n\n/* La hoja que se imprime para el taller: el cliente, el pedido y sus líneas, nada más.\n   Fuera las horas, el albarán y los partes, que son cosa de la oficina. */\n@media print {\n  body { background: #fff !important; }\n  .header, .order-back, .order-head-actions, .order-cards, .order-modal-fondo,\n  .order-section-albaran, .order-section-partes, .order-card-link { display: none !important; }\n  .order-detail { padding: 0; max-width: 100%; }\n  .order-section { break-inside: avoid; }\n}\n\n/* LAKPED-25: adjuntar el documento del cliente desde el pedido. El input va escondido dentro del botón. */\n.order-detail .order-adjuntar { position: relative; overflow: hidden; display: inline-block; }\n.order-detail .order-adjuntar input { position: absolute; inset: 0; opacity: 0; cursor: pointer; }\n.order-detail .order-adjuntar.ocupado { opacity: 0.6; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
